<app-centered-page-wrapper>
  <app-loading-spinner *ngIf="verifyingToken;else main_content"></app-loading-spinner>
  <ng-template #main_content>
    <h1 *ngIf="welcome && tokenValid">Welcome to Joy School! <ng-container *ngIf="!reset">Please set your password.</ng-container></h1>
    <h1 *ngIf="welcome && !tokenValid">Welcome back!</h1>
    <h1 *ngIf="!welcome">Reset Password</h1>
    <div *ngIf="tokenValid; else invalid">
      <p *ngIf="reset; else content">
        Password set successfully. You can now
        <a class="accent" routerLink="/login"> log in </a>
        with your new password.
        <a routerLink="/login" class="d-block mt-3">
          <button class="btn btn-primary">
            RETURN TO LOGIN
          </button>
        </a>
      </p>
      <ng-template #content>
        <div class="form-group">
          <label for="password">Enter new password</label>
          <input class="form-control" [(ngModel)]="password" id="password" name="password" required type="password" 
              (keyup.enter)="resetPassword()" (change)="validatePassword()">
        </div>
        <div class="form-group">
          <label for="passwordConfirm">Confirm password</label>
          <input class="form-control" [(ngModel)]="passwordConfirm" id="passwordConfirm" name="passwordConfirm" required type="password"
            (keyup.enter)="resetPassword()">
        </div>
        <div class="error-message" *ngIf="passwordErrors.length">The password must be at least 8 characters</div>
        <div class="error-message" *ngIf="passwordErrors.upper">The password must contain an upper case letter</div>
        <div class="error-message" *ngIf="passwordErrors.lower">The password must contain a lower case letter</div>
        <div class="error-message" *ngIf="passwordErrors.other">The password must contain a number or symbol</div>
        <button class="btn btn-primary" (click)="resetPassword()" [disabled]="resetting">
          <app-loading-spinner *ngIf="resetting" [text]="welcome && 'SETTING...' || 'RESETTING...'"></app-loading-spinner>
          <ng-container *ngIf="!resetting">{{ welcome && 'SET PASSWORD' || 'RESET' }}</ng-container>
        </button>
      </ng-template>
    </div>
    <ng-template #invalid>
      <p *ngIf="welcome">
        It looks like you have already set your password. You can
        <a class="accent" routerLink="/login">
          log in here
        </a>
        . If you forgot your password,
        <a class="accent" routerLink="/forgot-password">
          request to reset it
        </a>.
      </p>
      <p *ngIf="!welcome">
        This link is not valid. Password reset links are valid for one day after creation and may not be reused. You can always
        <a class="accent" routerLink="/forgot-password"> request another link </a>.
      </p>
    </ng-template>
  </ng-template>
</app-centered-page-wrapper>
